// extracted by mini-css-extract-plugin
export default {"svg_path":"svg_path__Q0hoZ","spinning":"spinning__S5Xzl","rotating":"rotating__sY5af"};